import { createAction } from '@reduxjs/toolkit';
import {
  CLOSE_CANCEL_PAYMENT_MODAL,
  CLOSE_PAYMENT_PROOF_MODAL,
  OPEN_PAYMENT_PROOF_MODAL,
} from 'constants/payment';
import {
  CLOSE_MODAL_REMAINING_BALANCE_PAYMENT_CREATED,
  OPEN_MODAL_REMAINING_BALANCE_PAYMENT_CREATED,
} from 'constants/recurringReceivables';
import {
  CLOSE_DUPLICATED_TAX_PAYMENT_MODAL,
  CLOSE_PARTNER_MODAL,
  CONFIRM_TAX_MODAL,
  MARK_PARTNER_MODAL_COMPLETED,
  OPEN_PARTNER_MODAL,
  RESET_PARTNER_MODAL,
  SET_PARTNER_MODAL_FIELDS,
} from 'constants/ui';

export const confirmTax = () => ({
  type: CONFIRM_TAX_MODAL,
  payload: true,
});

export const closeDuplicatedTaxPaymentModal = () => ({
  type: CLOSE_DUPLICATED_TAX_PAYMENT_MODAL,
});

export const openPaymentProofModal = () => ({
  type: OPEN_PAYMENT_PROOF_MODAL,
});

export const closePaymentProofModal = () => ({
  type: CLOSE_PAYMENT_PROOF_MODAL,
});

export const closePaymentCancellationFailedModal = () => ({
  type: CLOSE_CANCEL_PAYMENT_MODAL,
});

export const openPaymentCreatedModal = () => ({
  type: OPEN_MODAL_REMAINING_BALANCE_PAYMENT_CREATED,
});

export const closePaymentCreatedModal = () => ({
  type: CLOSE_MODAL_REMAINING_BALANCE_PAYMENT_CREATED,
});

export const openPartnerModal = createAction(OPEN_PARTNER_MODAL);
export const closePartnerModal = createAction(CLOSE_PARTNER_MODAL);
export const markPartnerModalCompleted = createAction(
  MARK_PARTNER_MODAL_COMPLETED,
);
export const resetPartnerModal = createAction(RESET_PARTNER_MODAL);
export const setPartnerModalFields = createAction<Record<string, string>>(
  SET_PARTNER_MODAL_FIELDS,
);
